import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

export default class Spinner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spinningState: this.props.spinningState,
    };

    this.spinnerRef = null;

    this.setSpinnerRef = element => {
      this.spinnerRef = element;
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.spinningState !== this.state.spinningState) {
      this.setState({
        spinningState: nextProps.spinningState,
      });

      if (nextProps.spinningState === 'spinning') {
        this.spinnerRef.classList.add('uni-spinner--spinning');
      }
    }
  }

  render() {
    const handleAnimationIteration = () => {
      if (this.state.spinningState === 'stopped') {
        this.spinnerRef.classList.remove('uni-spinner--spinning');
        this.spinnerRef.classList.add('uni-spinner--stopped');
      }
    };

    const handleAnimationEnd = () => {
      if (this.state.spinningState === 'stopped') {
        this.spinnerRef.classList.remove('uni-spinner--stopped');

        this.props.onSpinningStopped && this.props.onSpinningStopped();
      }
    };

    const spinnerClasses = classNames('uni-spinner', 'uni-spinner--spinning', {
      [`uni-spinner--${this.props.size}`]: this.props.size,
    });

    return (
      <div className="uni-spinner__container">
        <svg className={spinnerClasses} viewBox="0 0 32 32" data-qa-id={this.props.qaId} ref={this.setSpinnerRef}>
          <g fill="none" fillRule="evenodd">
            <path
              className="uni-spinner__circle"
              strokeWidth="3"
              d="M16,27.5 C22.3512746,27.5 27.5,22.3512746 27.5,16 C27.5,9.64872538 22.3512746,4.5
          16,4.5 C9.64872538,4.5 4.5,9.64872538 4.5,16 C4.5,22.3512746 9.64872538,27.5 16,27.5 Z"
            />
            <path
              onAnimationIteration={handleAnimationIteration}
              onAnimationEnd={handleAnimationEnd}
              className="uni-spinner__stroke"
              strokeWidth="3"
              d="M16,27.5 C22.3512746,27.5 27.5,22.3512746 27.5,16 C27.5,9.64872538 22.3512746,4.5
          16,4.5 C9.64872538,4.5 4.5,9.64872538 4.5,16 C4.5,22.3512746 9.64872538,27.5 16,27.5 Z"
            />
          </g>
        </svg>
      </div>
    );
  }
}

Spinner.propTypes = {
  size: PropTypes.PropTypes.oneOf(['small', 'medium', 'large']),
  spinningState: PropTypes.oneOf(['spinning', 'stopped']),
  onSpinningStopped: PropTypes.func,
  qaId: PropTypes.string,
};

Spinner.defaultProps = {
  size: 'medium',
  spinningState: 'spinning',
};



// WEBPACK FOOTER //
// ./src/spinner/index.jsx